import Typography from '@mui/material/Typography';
import { getFilterDocument } from 'features/smart-lists';
import { useTasksByFilterDocument } from 'features/tasks/hooks/use-tasks-by-filter-document/use-tasks-by-filter-document';
import React, { useMemo } from 'react';
import { Lock12 } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { SmartList } from 'shared/types/smart-list';

import * as Styled from './smart-list-count.style';

export type SmartListCountProps = {
  smartList: SmartList;
};

export const SmartListCount: React.FC<SmartListCountProps> = ({
  smartList,
}) => {
  const activeFilterDocument = useMemo(
    () => getFilterDocument(smartList),
    [smartList],
  );

  const tasks = useTasksByFilterDocument(activeFilterDocument);

  if (smartList.frozenAt) {
    return (
      <Styled.Container>
        <Icon icon={Lock12} />
      </Styled.Container>
    );
  }

  return !!tasks.length ? (
    <Styled.Container>
      <Typography variant="overline" component="span">
        {tasks.length}
      </Typography>
    </Styled.Container>
  ) : null;
};
